import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {provideClientHydration, withEventReplay, withHttpTransferCacheOptions, withIncrementalHydration} from '@angular/platform-browser';
import {CoreModule} from "@biletix/core/core.module";
// import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { I18nService } from './core/services/i18n.service';
import {APP_BASE_HREF, LOCATION_INITIALIZED} from '@angular/common';
import {environment} from "@biletix/env";
import { GlobalConfig, ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app';
import { AppRoutingModule } from './app-routing-module';

export function appInitializerFactory(i18n: I18nService, injector: Injector) {
    return () => new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      locationInitialized.then(() => {
        console.log("appmoduleBaseHref: ", environment.baseHref );
        const locale = i18n.getLocale();
        i18n.useLanguage(locale).subscribe(() => {
          console.info(`Successfully initialized '${i18n.currentLang}' language.'`);
        }, err => {
          console.error(`Problem with '${i18n.currentLang}' language initialization.'`, err);
        }, () => {
          resolve(null);
        });
      });
    });
}

const toastrConfig: Partial<GlobalConfig> = {
    closeButton: true,
    enableHtml: true,
    // extendedTimeOut: 2000,
    // progressAnimation: "increasing",
    timeOut: 10000,
    newestOnTop: true,
    onActivateTick: true,
    maxOpened: 3,
    autoDismiss: true,
    preventDuplicates: true,
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        //core
        CoreModule,
        AppRoutingModule,
        ToastrModule.forRoot(toastrConfig),
        // GoogleTagManagerModule.forRoot({
        //     id: 'GTM-K4QMLG',
        //     // gtm_auth: YOUR_GTM_AUTH,
        //     // gtm_preview: YOUR_GTM_ENV
        // })
    ],
    providers: [
        // SSR ile render edilen DOM'u client'ta yeniden kurmak yerine hydrate eder.
        // withEventReplay: hydration tamamlanmadan önceki kullanıcı etkileşimlerini yakalar.
        // withHttpTransferCacheOptions: SSR sırasında yapılan GET çağrılarının yanıtını
        // TransferState'e koyar, böylece tarayıcı aynı homePage API'lerini tekrar çekmez (çift fetch biter).
        // withIncrementalHydration: `@defer (hydrate on viewport)` bloklarını sunucu tam render eder
        // (SEO içeriği HTML'de kalır), tarayıcı ise yalnızca görünür olunca hidrat eder (TBT düşer).
        provideClientHydration(
            withEventReplay(),
            withIncrementalHydration(),
            withHttpTransferCacheOptions({
                includePostRequests: false,
            }),
        ),
        {
          provide: APP_BASE_HREF,
          useValue: environment.baseHref
        },
        {
          provide: 'googleTagManagerCSPNonce',
          useValue: 'CSP-NONCE'
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [I18nService, Injector],
            multi: true
        }
    ],
    bootstrap: [AppComponent]

})
export class AppModule {

    //TODO:Silinecek . Router config olarak verildi. Özelleştirilmek isteniyorsa kullanılabilir.

    // constructor(router: Router, viewportScroller: ViewportScroller) {
    //     router.events.pipe(
    //         filter((e: Event): e is Scroll => e instanceof Scroll)
    //     ).subscribe(e => {
    //             if (e.position) {
    //                 // backward navigation
    //                 viewportScroller.scrollToPosition([0, 0]);
    //             } else if (e.anchor) {
    //                 // anchor navigation
    //                 viewportScroller.scrollToAnchor(e.anchor);
    //             } else {
    //                 // forward navigation
    //                 viewportScroller.scrollToPosition([0, 0]);
    //             }
    //         }
    //     );
    //
    // }
}
